import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { Observable, forkJoin } from 'rxjs';
import { ApiUrlConstants } from '../../shared/constants/api_url_constants';
import { ApiResponse } from '../../shared/common-model/common.model';
import { soAddDTO, soClientProvideLaborInfoBaseAddDTO,  soUpdateGeneralInfoAddUpdateDTO, soViewModel, soViewModelForDetails } from '../models/service-order.model';
import { SpinnerService } from '../../shared/services/spinner.service';
import { CommonToastService } from '../../shared/services/common-toast.service';
import { ClientService } from '../../admin/services/client-management/client.service';
import { soFieldFilesViewModel, soScopeBoothFieldAddUpdateDTO, soScopeBoothFieldElementAddUpdateDTO, soScopeBoothFieldElementViewModel, soScopeBoothFieldFilePrint, soScopeBoothFieldFilesViewModel } from '../models/service-order-scope-booth.model';
import { printDocumentForShowViewModel, soFieldFilePrintDownloadIdFileSource } from '../models/service-order-prepare-inbound.model';
import { printDocumentsForShowDTO } from '../../job-labor-planning/models/job-labor-planning.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceOrderScopeBoothService {
  constructor(private httpRequestService: HttpRequestService, private spinnerService:SpinnerService, 
    private commonToastService:CommonToastService, private clientService:ClientService) { }

  getAllSoScopeBoothFieldElement(soId: any): Observable<soScopeBoothFieldElementViewModel[]> {
    return this.httpRequestService.getData<soScopeBoothFieldElementViewModel[]>(`${ApiUrlConstants.soScopeGetAllBoothFieldElement}${soId}`);
  }
  getAllSoScopeBoothFieldFile(soId: any): Observable<soScopeBoothFieldFilesViewModel[]> {
    return this.httpRequestService.getData<soScopeBoothFieldFilesViewModel[]>(`${ApiUrlConstants.soScopeGetAllBoothFieldFiles}${soId}`);
  }
  getAllSoFieldFiles(soId: any): Observable<soFieldFilesViewModel> {
     //This include SO Booth Field files + Inbound Files + Outbound files + Show Quick Facts, COI, Floor Plan
    return this.httpRequestService.getData<soFieldFilesViewModel>(`${ApiUrlConstants.soGetAllFieldFiles}${soId}`);
  }
  addUpdateSoScopeBoothField(data: soScopeBoothFieldAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soScopeBoothFieldAddUpdateDetails, data);
  }
  addUpdateSoScopeBoothFieldElement(data: soScopeBoothFieldElementAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soScopeBoothFieldElementAddUpdateDetails, data);
  }
  uploadSoScopeBoothFieldFile(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.soScopeBoothFieldFileUpload, data);
  }
  downloadSoScopeBoothFieldFile(fileDocId: any): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.soScopeBoothFieldFileDownload}${fileDocId}`);
  }
  deleteSoScopeBoothFieldFile(fileDocId: any): Observable<any> {
    return this.httpRequestService.deleteData(`${ApiUrlConstants.soScopeBoothFieldFileDelete}${fileDocId}`);
  }
  deleteSoScopeBoothFieldElement(id: any): Observable<any> {
    return this.httpRequestService.deleteData(`${ApiUrlConstants.soScopeBoothFieldElementDelete}${id}`);
  }
  getAllBoothDetails(soId: string): Observable<any[]> {
    const getBoothElements = this.httpRequestService.getData<soScopeBoothFieldElementViewModel[]>(`${ApiUrlConstants.soScopeGetAllBoothFieldElement}${soId}`);
    const getBoothFiles = this.httpRequestService.getData<soScopeBoothFieldFilesViewModel[]>(`${ApiUrlConstants.soScopeGetAllBoothFieldFiles}${soId}`);
    return forkJoin([getBoothElements, getBoothFiles ]);
  }
  downloadZipSoScopeBoothFieldFile(fildata: any): Observable<any> {
    return this.httpRequestService.postFileData(ApiUrlConstants.soScopeBoothFieldFileDownloadZip, fildata);
  }
  printSoScopeBoothFieldFile(fildata: any): Observable<soScopeBoothFieldFilePrint[]> {
    return this.httpRequestService.postData<soScopeBoothFieldFilePrint[]>(ApiUrlConstants.soScopeBoothFieldPrint, fildata);
  }
  printSOFieldFiles(fildata: soFieldFilePrintDownloadIdFileSource[]): Observable<soScopeBoothFieldFilePrint[]> {
    return this.httpRequestService.postData<soScopeBoothFieldFilePrint[]>(ApiUrlConstants.soFieldFilesPrint, fildata);
  }
  printDocumentsForShow(fildata: printDocumentsForShowDTO): Observable<printDocumentForShowViewModel[]> {
    return this.httpRequestService.postData<printDocumentForShowViewModel[]>(ApiUrlConstants.soPrintDocumentForShow, fildata);
  }
  downloadZipSoFiledFieldFile(fildata: soFieldFilePrintDownloadIdFileSource[]): Observable<any> {
    return this.httpRequestService.postFileData(ApiUrlConstants.soFieldFileDownloadZip, fildata);
  }
}
